import { z } from 'zod';
import { OBJECT_ID_RE } from './object-id.schema';
/**
 * Entity-link vocabulary shared by every chat agent (app chat, Bliksy).
 * Both agents emit `entity://<type>/<id>` links inside markdown answers and
 * persist structured `entityRefs` alongside each message, so the vocabulary
 * lives in `shared/` rather than under a single feature.
 */ export const CHAT_ENTITY_TYPES = [
    'user',
    'process',
    'team',
    'system',
    'department',
    'artifact',
    'externalContact'
];
export const ChatEntityTypeSchema = z.enum(CHAT_ENTITY_TYPES);
/**
 * A structured reference to an entity mentioned in a chat message — persisted
 * per message so reload renders source chips without re-parsing markdown.
 * `name` is a denormalized display label captured at write time.
 */ export const ChatEntityRefSchema = z.object({
    type: ChatEntityTypeSchema,
    id: z.string().regex(OBJECT_ID_RE, 'Invalid ObjectId format'),
    name: z.string().optional()
});
/**
 * Matches every `entity://<type>/<24-hex-id>` link in a block of markdown.
 * Global + case-insensitive: scan with `text.matchAll(ENTITY_LINK_REGEX)`
 * (never `.test()`/`.exec()` in a loop — the `g` flag makes those stateful).
 * Capture groups: 1 = raw type string, 2 = ObjectId.
 */ export const ENTITY_LINK_REGEX = /entity:\/\/(\w+)\/([a-f\d]{24})/gi;

//# sourceMappingURL=chat-entity.js.map